import { InjectionToken } from '@angular/core';

export interface AppConfig {
  production: boolean;
  name: string;
  apiUrl: string;
  itemsPerPage: number;
  /** Texte affiché dans le ruban d'environnement (vide = pas de ruban) */
  ribbonLabel: string;
  loginRoute?: string;
  /** cs – image de fond de la page login */
  backgroundImage?: string;
  /** cs – liste des assureurs séparés par ; */
  insuranceList?: string;
  /** cs – liste des distributeurs Orchestra séparés par ; */
  orchestraList?: string;
  /** cs – liste des distributeurs TravelExchange séparés par ; */
  travelexchangeList?: string;
  /** cs – base URL Hewago (lien dossier baleno) */
  hewagoUrl?: string;
  /** cs – base URL du nouveau back-office (lien vers le voyage d'un produit migré) */
  newBackOfficeUrl?: string;
  /** admin – email administrateur */
  adminEmail?: string;
  /** admin – URL du scheduler */
  schedulerApiUrl?: string;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('Application config');